import { defineStore } from 'pinia';

import {
  SET_CURRENT_USER,
  SET_USER_GROUPS,
} from '@/store/mutation-types';
import { msalInstance } from '@/auth/msalInstance';

export const ENV = (import.meta.env.VITE_ENVIRONMENT || import.meta.env.MODE || 'dev').toLowerCase();

export const GROUP_IDS_BY_ENV = {
  dev: {
    MARINLIT:     '12efd4c9-c75c-4b05-8b11-32460c85a66a',
    MERCKINDEX:   '0f2e6320-d8b7-49c2-8e6f-1f9d1ddeae50',
    CHEMSPIDER:   '31875520-c7e9-42f7-8661-26a3b85806c2',
  },
  uat: {
    MARINLIT:     '2bb67532-0ddc-4504-88e0-7655c62a595c',
    MERCKINDEX:   '81e2958f-5aab-4a8b-8f52-0145004ced18',
    CHEMSPIDER:   '942c11e3-921d-4163-869c-6bf8896c506f',
  },
  prod: {
    MARINLIT:     '4d3ad92e-6e82-403e-85fd-46d344455b77',
    MERCKINDEX:   '09b55a3d-b7cb-411b-89cf-f2bdca6e72e0',
    CHEMSPIDER:   '706b7060-8215-45d3-afff-39cffc293ff7',
  }
};

const GROUP_IDS = GROUP_IDS_BY_ENV[ENV] || {};

export const useAuthStore = defineStore('auth', {

  state: () => ({
    currentUser: null,
    currentGroups: [],
    accessToken: null,
  }),

  actions: {

    [SET_CURRENT_USER](value) {
      this.currentUser = value;
    },

    [SET_USER_GROUPS](value) {
      this.currentGroups = value || [];
    },

    setAccessToken(token) {
      this.accessToken = token;
    },

    async updateAuth() {
      const account = msalInstance.getActiveAccount();
      // START --local user bypass --
      if (!account || !import.meta.env.PROD) {
        this[SET_CURRENT_USER]({ name: 'Local Dev User', username: 'localdev' });
        this[SET_USER_GROUPS](Object.values(GROUP_IDS_BY_ENV.dev));
        this.setAccessToken('local-dev-token'); // opcional, para no romper getters
        return;
      }
      // END --local user bypass --

      if (!account) {
        return;
      }

      // Get idToken to retrieve reliable claims
      const idTokenResponse = await msalInstance.acquireTokenSilent({
        account,
        scopes: ['openid', 'profile', 'email']
      });

      const claims = idTokenResponse.idTokenClaims || {};

      // User info
      this[SET_CURRENT_USER]({
        name: claims.name || account.name,
        username: claims.preferred_username || claims.email || account.username || account.homeAccountId,
      });

      // Groups from claims
      const groups = claims.groups || [];
      this[SET_USER_GROUPS](groups);

      // Get accessToken to call API
      const apiTokenResponse = await msalInstance.acquireTokenSilent({
        account,
        scopes: [import.meta.env.VITE_AZURE_API_SCOPE]
      });

      this.setAccessToken(apiTokenResponse.accessToken);
    }
  },

  getters: {
    userName: state => state.currentUser?.name || '',
    userGroups: state =>
      state.currentGroups.filter(g =>
        Object.values(GROUP_IDS).includes(g)
      ),
    userProducts() {
      const products = [];
      if (!this.userGroups || !GROUP_IDS) return products;
      if (this.userGroups.includes(GROUP_IDS.MARINLIT))     products.push('MarinLit');
      if (this.userGroups.includes(GROUP_IDS.MERCKINDEX))   products.push('MerckIndex');
      if (this.userGroups.includes(GROUP_IDS.CHEMSPIDER)) { products.push('CSDepositions'); products.push('Curation') }
      return products;
    },
  },
});